import React, { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import TrainingSchedule from "./TrainingSchedule";
import TrainingScheduleModal from "./TrainingScheduleModal";
import Loader from "../loader/Loader";

function TrainingScheduleNew({ show, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [trainingSchedule, setTrainingSchedule] = useState(false);
  const [trainingScheduleModal, setTrainingScheduleModal] = useState(false);
  const [trainingData, setTrainingData] = useState([]);
  const [trainingId, setTrainingId] = useState(null)

  const fetchTrainingList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/trainingschedule`, {
        headers: { Authorization: `Bearer ${token}` }
      });
       if (response?.data && response?.data) {
      setTrainingData(response?.data?.training || []);
    } else {
      setTrainingData([]);
    }
    } catch (err) {
      console.error("Error fetching training list:", err.message);
    } finally {
      setLoading(false);
    }
  };

   useEffect(() => {
    if (show) {
      fetchTrainingList();
    }
  }, [show]);

  // console.log(trainingData,"trainingData")

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Body className="m-4 font_family">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="fw-bold mb-0">Training Schedule</h4>
            <Button
              variant="dark"
              size="sm"
              className="fw-bold"
              onClick={() => setTrainingSchedule(true)}
            >
              Schedule New Training
            </Button>
          </div>

          <Table bordered hover responsive className="align-middle">
            <thead>
              <tr>
                <th>Date of Training</th>
                <th>Type of Training</th>
                <th>Participants</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    <Loader />
                  </td>
                </tr>
              ) : trainingData && trainingData.length > 0 ? (
                trainingData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.training_date}</td>
                    <td>{item.training_category.name}</td>
                    <td>{item.total_participants}</td>
                    <td className="text-center">
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {
                          setTrainingScheduleModal(true);
                          setTrainingId(item?.training_code);
                        }}
                      >
                        View Details
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="text-end mt-3">
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>


      <TrainingSchedule
        show={trainingSchedule}
        handleClose={() => setTrainingSchedule(false)}
      />

      <TrainingScheduleModal
        show={trainingScheduleModal}
        trainingId={trainingId}
        handleClose={() => setTrainingScheduleModal(false)}
      />
    </>
  );
}

export default TrainingScheduleNew;
